import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, Chip } from '@mui/material';
import { StyledContainer } from './styles';

interface Reason {
  id: number;
  name: string;
  value: string;
}

export interface ReasonsMultiSelectAutocompleteProps {
  /** Valores selecionados (strings dos motivos) */
  value?: string[];
  /** Função chamada quando os valores mudam */
  onChange: (value: string[]) => void;
  /** Label do campo */
  label?: string;
  /** Se o componente está desabilitado */
  disabled?: boolean;
  /** Placeholder quando nenhum item está selecionado */
  placeholder?: string;
  /** Loading externo */
  loading?: boolean;
}

const reasonsOptions: Reason[] = [
  { id: 1, name: "Não entregues", value: "Não entregue" },
  { id: 2, name: "Amassados/Quebrados", value: "Amassado/Quebrado" },
  { id: 3, name: "Entregas Erradas", value: "Entregue errado" },
];

export const ReasonsMultiSelectAutocomplete = ({
  value = [],
  onChange,
  label = "Motivos",
  disabled = false,
  placeholder = "Selecione os motivos",
  loading = false
}: ReasonsMultiSelectAutocompleteProps) => {
  const [selectedOptions, setSelectedOptions] = useState<Reason[]>([]);

  // Atualiza os valores selecionados quando o prop value muda
  useEffect(() => {
    if (value && value.length > 0) {
      const selected = reasonsOptions.filter(option => value.includes(option.value));
      setSelectedOptions(selected);
    } else {
      setSelectedOptions([]);
    }
  }, [value]);

  const handleChange = (_: any, newValue: Reason[]) => {
    setSelectedOptions(newValue);
    const values = newValue.map(option => option.value);
    onChange(values);
  };

  const getOptionLabel = (option: Reason) => {
    return option.name;
  };

  return (
    <StyledContainer>
      <Autocomplete
        multiple
        options={reasonsOptions}
        value={selectedOptions}
        onChange={handleChange}
        getOptionLabel={getOptionLabel}
        disabled={disabled || loading}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => (
            <Chip
              {...getTagProps({ index })}
              key={option.id}
              label={option.name}
              size="small"
              sx={{
                backgroundColor: '#89BD23',
                color: 'white',
                '& .MuiChip-deleteIcon': {
                  color: 'white',
                  '&:hover': {
                    color: '#f0f0f0'
                  }
                }
              }}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={selectedOptions.length === 0 ? placeholder : ''}
          />
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        filterSelectedOptions
        sx={{
          '& .MuiOutlinedInput-root': {
            padding: '8px 12px',
          }
        }}
      />
    </StyledContainer>
  );
};
